// @flow

import { SentryGASv3Listener } from '@atlassian/mpac-utils';
import styled from '@emotion/styled';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import CommonPropTypes from '../../../constants/PropTypes';
import AddonDiscoveryConfig from '../../../records/AddonDiscoveryConfig';
import CollectionsConfig from '../../../records/CollectionsConfig';
import CommonConfig from '../../../records/CommonConfig';
import SolutionsConfig from '../../../records/SolutionsConfig';
import VendorDetailsConfig from '../../../records/VendorDetailsConfig';
import TelemetryNavigationListener from '../../../telemetry/TelemetryNavigationListener';
import getAllRoutes from '../allRoutes';
import { getMatchedRoute, resolveCurrentRoute } from '../utils/RouteUtils';
import RouteContainer from './RouteContainer';

export const MainContent = styled.div`
  min-height: 100vh;
  position: relative;

  .absolute-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

// Keep in sync with React `PropTypes`
type Props = {
  commonConfig: CommonConfig,
  addonDiscoveryConfig: AddonDiscoveryConfig,
  collectionsConfig: CollectionsConfig,
  solutionsConfig: SolutionsConfig,
  vendorDetailsConfig: VendorDetailsConfig,
};

export default class Routes extends Component<Props> {
  static propTypes = {
    commonConfig: CommonPropTypes.commonConfig.isRequired,
    addonDiscoveryConfig: CommonPropTypes.addonDiscoveryConfig.isRequired,
    collectionsConfig: CommonPropTypes.collectionsConfig.isRequired,
    solutionsConfig: CommonPropTypes.solutionsConfig.isRequired,
    vendorDetailsConfig: CommonPropTypes.vendorDetailsConfig.isRequired,
  };

  render() {
    const allRoutes = () =>
      getAllRoutes({
        addonDiscoveryConfig: this.props.addonDiscoveryConfig,
        collectionsConfig: this.props.collectionsConfig,
        solutionsConfig: this.props.solutionsConfig,
        vendorDetailsConfig: this.props.vendorDetailsConfig,
      });

    const RenderRoutes = props => {
      const routeList = allRoutes();
      const getRouteName = (pathname: string) => resolveCurrentRoute(routeList, pathname)?.name;
      const getRouteParams = (pathname: string) => getMatchedRoute(routeList, pathname)?.params;

      return (
        <RouteContainer {...props} allRoutes={routeList}>
          <TelemetryNavigationListener getRouteName={getRouteName} />
          <SentryGASv3Listener getRouteName={getRouteName} getRouteParams={getRouteParams}>
            <MainContent>
              <Switch>
                {allRoutes()
                  .filter(route => !route.isNestedRoute)
                  .map(({ path, render, component, exact }) => (
                    // We avoid using keys on each of the routes so that there is not a full re-render
                    // of the AddonDiscovery components. If we fully re-render the AddonDiscovery components,
                    // we needlessly re-retrieve data and there is more flashing on screen
                    // eslint-disable-next-line react/jsx-key
                    <Route path={path} exact={exact} render={render} component={component} />
                  ))}
              </Switch>
            </MainContent>
          </SentryGASv3Listener>
        </RouteContainer>
      );
    };

    return <Route path="/" render={RenderRoutes} />;
  }
}
